import { create } from 'zustand'
import { upgraderApi } from '../services'

const useUpgraderStore = create((set, get) => ({
  // Состояние
  availableItems: [], // Список доступных скинов для апгрейда (шаг 1)
  multipliers: {}, // Объект с мультипликаторами и скинами (шаг 2) { "1.5": [...], "2": [...] }
  donor: null, // Информация о выбранном донор-предмете
  isLoading: false,

  // Установка доступных предметов (вызывается из api.js)
  setAvailableItems: (items) => {
    console.log('📦 Установка доступных скинов в store:', items?.length || 0)
    set({ availableItems: items || [] })
  },

  // Загрузка доступных предметов для апгрейда
  loadAvailableItems: async () => {
    set({ isLoading: true })
    try {
      const items = await upgraderApi.getAvailableItems()
      
      // Устанавливаем данные напрямую в store
      // (данные уже обработаны в upgraderApi с маппингом cost → price)
      set({ availableItems: items || [] })
      
      return items
    } catch (error) {
      console.error('❌ Ошибка загрузки скинов для апгрейда:', error)
      set({ availableItems: [] })
      throw error
    } finally {
      set({ isLoading: false })
    }
  },

  // Загрузка мультипликаторов для выбранного предмета (шаг 2)
  loadMultipliers: async (itemId) => {
    set({ isLoading: true })
    try {
      const { multipliers, donor } = await upgraderApi.getMultipliers(itemId)
      
      // Устанавливаем мультипликаторы и донор-предмет в store
      set({ 
        multipliers: multipliers || {}, 
        donor: donor || null 
      })
      
      return { multipliers, donor }
    } catch (error) {
      console.error('❌ Ошибка загрузки мультипликаторов:', error)
      set({ multipliers: {}, donor: null })
      throw error
    } finally {
      set({ isLoading: false })
    }
  },

  // Расчет шанса апгрейда (шаг 3)
  calculateChance: async (donorId, targetId) => {
    set({ isLoading: true })
    try {
      const { donor, target, chance } = await upgraderApi.calculateChance(donorId, targetId)
      
      // Обновляем состояние с полученными данными
      set({ 
        donor: donor
      })
      
      return { donor, target, chance }
    } catch (error) {
      console.error('❌ Ошибка расчета шанса:', error)
      throw error
    } finally {
      set({ isLoading: false })
    }
  },

  // Выполнение апгрейда (шаг 4)
  performUpgrade: async (donorId, targetId) => {
    set({ isLoading: true })
    try {
      const { donor, target, chance, win, firstSuccessUpgrade } = await upgraderApi.performUpgrade(donorId, targetId)
      
      return { donor, target, chance, win, firstSuccessUpgrade }
    } catch (error) {
      console.error('❌ Ошибка выполнения апгрейда:', error)
      throw error
    } finally {
      set({ isLoading: false })
    }
  },

}))

export default useUpgraderStore
